<div (click)="openCreateUserModal()" *ngIf="employee?.userActive === undefined && !isExternalAdmin"
     class="dropdown-item pointer">
  {{ 'SETTINGS.user_rights.create_user' | translate }}
</div>
<div (click)="activateUser(true)" *ngIf="employee?.userActive === false && !isExternalAdmin"
     class="dropdown-item pointer">
  {{ 'SETTINGS.user_rights.activate_user' | translate }}
</div>
<div (click)="activateUser(false)" *ngIf="employee?.userActive === true && !isExternalAdmin && !readonly"
     class="dropdown-item pointer">
  {{ 'SETTINGS.user_rights.deactivate_user' | translate }}
</div>

<ng-container *ngIf="isTransferAccessMenuVisible">
  <div (click)="openTransferUserAccessModal(employee)" *ngIf="employee?.userActive === true || isExternalAdmin"
       class="dropdown-item pointer">
    {{ 'SETTINGS.user_rights.transfer_access_to_users' | translate }}
  </div>
</ng-container>

<div (click)="openDeleteUserModal(employee?.id)" *ngIf="employee && isExternalAdmin"
     class="dropdown-item pointer">
  {{ 'SETTINGS.user_rights.delete_user' | translate }}
</div>
